import { getFusion } from '../apiHelper/fusionApi'

export function getPCCMedications(patientId, startDate = null) {
  return getFusion(
    `v1/patient/pccmedications/${patientId}${startDate ? `?startdate=${startDate}` : ''}`,
  )
}

export function getPCCAllergies(patientId, onsetDate = null) {
  return getFusion(
    `v1/patient/pccallergies/${patientId}${onsetDate ? `?onsetdate=${onsetDate}` : ''}`,
  )
}

export function getPCCImmunizations(patientId, revisionDate = null) {
  return getFusion(
    `v1/patient/pccimmunizations/${patientId}${revisionDate ? `?revisiondate=${revisionDate}` : ''}`,
  )
}

export function getPCCFunctionalStatus(patientId, recordedDate = null) {
  return getFusion(
    `v1/patient/pccactivitiesofdailyliving/${patientId}${recordedDate ? `?recordeddate=${recordedDate}` : ''}`,
  )
}

export function getPCCObservations(patientId, recordedDate = null) {
  return getFusion(
    `v1/patient/pccobservations/${patientId}${recordedDate ? `?recordeddate=${recordedDate}` : ''}`,
  )
}

export function getPCCConditions(patientId, onsetDate = null) {
  return getFusion(
    `v1/patient/pccconditions/${patientId}${onsetDate ? `?onsetdate=${onsetDate}` : ''}`,
  )
}

export function getPCCReport(patient_id, reportType, issuedDate = null) {
  return getFusion(
    `/v1/patient/pccdiagnosticreports/${patient_id}/${reportType}${issuedDate ? `?issueddate=${issuedDate}` : ''}`,
  )
}

export function getPCCResultFile(patient_id, reportId) {
  return getFusion(`/v1/patient/pccdiagnosticreportfile/${patient_id}/${reportId}`, {
    responseType: 'blob',
  })
}

export function getPCCData(patient_id) {
  return getFusion(`/v1/patient/pccdata/${patient_id}`)
}

export function getPCCCoverages(patient_id) {
  return getFusion(`/v1/patient/pcccoverages/${patient_id}`)
}

export function getPCCNotes(patient_id) {
  return getFusion(`/v1/patient/pccnotes/${patient_id}`)
}

export function getPCCNoteDetails(patient_id, note_id) {
  return getFusion(`/v1/patient/pccnotedetails/${patient_id}/${note_id}`)
}
